import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import "./CSS/varietyAccessories.css";
import { ToastContainer, toast } from "react-toastify";
import { isAdmin } from "../utils/roleUtils";
import "react-toastify/dist/ReactToastify.css";

const emptyForm = { name: "", city: "", rating: 5, message: "", show: true };

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [formData, setFormData] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const res = await axios.get(`${backend_url}/api/testimonial`);
      setTestimonials(res.data);
    } catch (error) {
      toast.error("Error fetching testimonials");
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      name: formData.name,
      city: formData.city,
      rating: Number(formData.rating),
      message: formData.message,
      show: formData.show,
    };
    try {
      if (editingId) {
        await axios.put(`${backend_url}/api/testimonial/${editingId}`, payload);
        toast.success("Testimonial updated successfully");
      } else {
        await axios.post(`${backend_url}/api/testimonial`, payload);
        toast.success("Testimonial added successfully");
      }
      fetchTestimonials();
      closeModal();
    } catch (error) {
      toast.error("Error saving testimonial");
    }
  };

  const handleEdit = (t) => {
    setFormData({
      name: t.name || "",
      city: t.city || "",
      rating: t.rating || 5,
      message: t.message || "",
      show: t.show !== false,
    });
    setEditingId(t._id);
    setShowModal(true);
  };

  const toggleShow = async (t) => {
    try {
      await axios.patch(`${backend_url}/api/testimonial/${t._id}/visibility`, {
        show: !t.show,
      });
      toast.success(t.show ? "Hidden from site" : "Now visible on site");
      fetchTestimonials();
    } catch (error) {
      toast.error("Failed to update visibility");
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setShowConfirm(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${backend_url}/api/testimonial/${selectedId}`);
      setShowConfirm(false);
      toast.success("Testimonial deleted successfully");
      fetchTestimonials();
    } catch (error) {
      toast.error("Error deleting testimonial");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingId(null);
    setFormData(emptyForm);
  };

  const renderStars = (rating) => {
    const filled = parseInt(rating, 10) || 0;
    return "★".repeat(filled) + "☆".repeat(5 - filled);
  };

  return (
    <>
      <div className="variety-admin">
        <div className="headerSections">
          <div className="head-title">Testimonials</div>
          <button className="add-btn" onClick={() => setShowModal(true)}>
            + Add Testimonial
          </button>
        </div>

        {/* Popup Modal */}
        {showModal && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <h2>{editingId ? "Edit Testimonial" : "Add Testimonial"}</h2>
              <form onSubmit={handleSubmit} className="variety-form">
                <div className="form-group">
                  <label htmlFor="name">Customer Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    maxLength={100}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="city">City</label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    maxLength={100}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="rating">Rating</label>
                  <select
                    id="rating"
                    name="rating"
                    value={formData.rating}
                    onChange={handleChange}
                  >
                    {[5, 4, 3, 2, 1].map((r) => (
                      <option key={r} value={r}>
                        {"★".repeat(r)} ({r})
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="message">Review Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    value={formData.message}
                    onChange={handleChange}
                    maxLength={800}
                    required
                  />
                </div>
                <div className="form-group" style={{ flexDirection: "row", alignItems: "center", gap: "8px" }}>
                  <input
                    type="checkbox"
                    id="show"
                    name="show"
                    checked={formData.show}
                    onChange={handleChange}
                    style={{ width: "auto" }}
                  />
                  <label htmlFor="show" style={{ margin: 0 }}>Show on website</label>
                </div>

                <div className="form-buttons">
                  <button type="submit" className="submit-btn">
                    {editingId ? "Update" : "Add"}
                  </button>
                  <button type="button" onClick={closeModal} className="cancel-btn">
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* List Table */}
        <table className="variety-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>City</th>
              <th>Rating</th>
              <th>Message</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {testimonials.length > 0 ? (
              testimonials.map((t) => (
                <tr key={t._id}>
                  <td>{t.name}</td>
                  <td>{t.city || "—"}</td>
                  <td style={{ color: "#f59e0b", letterSpacing: "1px" }}>{renderStars(t.rating)}</td>
                  <td style={{ maxWidth: 360 }}>{t.message}</td>
                  <td>
                    <span
                      style={{
                        padding: "3px 10px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: 600,
                        background: t.show ? "#dcfce7" : "#f3f4f6",
                        color: t.show ? "#16a34a" : "#6b7280",
                      }}
                    >
                      {t.show ? "Visible" : "Hidden"}
                    </span>
                  </td>
                  <td>
                    <button onClick={() => toggleShow(t)}>
                      {t.show ? "Hide" : "Show"}
                    </button>
                    <button onClick={() => handleEdit(t)}>Edit</button>
                    {isAdmin() && (
                      <button onClick={() => handleDelete(t._id)}>Delete</button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                  No testimonials yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Confirmation Popup */}
      {showConfirm && (
        <div className="confirm-popup">
          <div className="confirm-content">
            <p>Are you sure you want to delete this testimonial?</p>
            <div className="popup-actions">
              <button onClick={confirmDelete} className="confirm-btn">
                Confirm
              </button>
              <button onClick={() => setShowConfirm(false)} className="cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default Testimonials;
